const bestRecruit = [
    {
        image:"https://d2u3dcdbebyaiu.cloudfront.net/uploads/atch_img/1/e34dac077dca02e084204cab00b0a7db_crop.png",
        cp_image : "https://d2u3dcdbebyaiu.cloudfront.net/uploads/atch_img/1/e34dac077dca02e084204cab00b0a7db_crop.png",
        name:"스마일릴잉엔터",
        title:"백엔드 서비스 개발 포지션",
    },
    {
        image:"https://d2u3dcdbebyaiu.cloudfront.net/uploads/atch_img/1/e34dac077dca02e084204cab00b0a7db_crop.png",
        cp_image : "https://d2u3dcdbebyaiu.cloudfront.net/uploads/atch_img/1/e34dac077dca02e084204cab00b0a7db_crop.png",
        name:"ㅎㅅ회사",
        title:"프론트엔드 서비스 개발 포지션",
    },
    {
        image:"https://d2u3dcdbebyaiu.cloudfront.net/uploads/atch_img/1/e34dac077dca02e084204cab00b0a7db_crop.png",
        cp_image : "https://d2u3dcdbebyaiu.cloudfront.net/uploads/atch_img/1/e34dac077dca02e084204cab00b0a7db_crop.png",
        name:"고최이집",
        title:"컨텐츠 담당자",
    },
    {
        image:"https://d2u3dcdbebyaiu.cloudfront.net/uploads/atch_img/1/e34dac077dca02e084204cab00b0a7db_crop.png",
        cp_image : "https://d2u3dcdbebyaiu.cloudfront.net/uploads/atch_img/1/e34dac077dca02e084204cab00b0a7db_crop.png",
        name:"디어긴여",
        title:"고수익 알바 최저 시급 보장",
    }
]

export default bestRecruit;